const { groupBy, sumBy } = require("lodash");
const { DateTime } = require("luxon");
const { getAllTables } = require("../common/tables");

const luxonDate = (date) => DateTime.fromJSDate(date);

function geCapacity(shift, businessTables) {
  if (shift.availabilityType === "Volume Based") {
    return shift.capacity;
  }

  const tables = businessTables.filter((table) =>
    shift.tables.includes(table.uid)
  );
  const total = sumBy(tables, "maximumOccupancy");
  return total;
}

const defaultDay = {
  startTime: "",
  endTime: "",
  closeDay: "",
  openDay: "",
  allDay: false,
};

const getWeekDays = () => {
  const weekdays = [];
  let start = DateTime.local().startOf("week");
  const end = DateTime.local().endOf("week");
  while (start < end) {
    weekdays.push({ name: start.weekdayLong, day: start });
    start = start.plus({ days: 1 });
  }
  return weekdays;
};

function getClosedSchedule() {
  const schedule = {};
  const weekdays = getWeekDays();
  weekdays.forEach((item) => {
    schedule[item.name] = [defaultDay];
  });
}

const convertShiftTimes = (shifts, dateArg) => {
  return shifts.map((shift) => checkTimes(shift, dateArg));
};

const checkTimes = (shift, dateArg) => {
  const date = DateTime.fromJSDate(dateArg);
  const startTime = DateTime.fromJSDate(shift.startTime);
  const endTime = DateTime.fromJSDate(shift.endTime);
  const startHour = startTime.hour;
  const startMinutes = startTime.minute;
  const endHour = endTime.hour;
  const endMinutes = endTime.minute;

  const start = date.set({
    hour: startHour,
    minute: startMinutes,
    second: 0,
    millisecond: 0,
  });
  const end = date.set({
    hour: endHour <= startHour ? endHour + 24 : endHour,
    minute: endMinutes,
    second: 0,
    millisecond: 0,
  });

  return {
    ...shift,
    startTime: start.toJSDate(),
    endTime: end.toJSDate(),
  };
};

const getTime = (date) => {
  const time = luxonDate(date).toLocaleString(DateTime.TIME_24_SIMPLE);
  const [hour, minute] = time.split(":");
  if (hour === "24") return "00:00";
  return time;
};

function getShiftTime(shift, time, type) {
  if (type === "special") {
    return shift?.openOrClose ? getTime(time) : "";
  } else {
    return getTime(time);
  }
}

function getShiftDay(shift, time, type) {
  if (type === "special") {
    return shift?.openOrClose ? luxonDate(time).weekdayLong : "";
  } else {
    return luxonDate(time).weekdayLong;
  }
}

function generateSchedule(business, shifts, allTables, type) {
  const availableDays = [];
  const schedule = {};
  const weekdays = getWeekDays();
  shifts.forEach((shift) => {
    weekdays.forEach((item) => {
      if (shift.operatingDays.includes(item.name)) {
        availableDays.push({ ...shift, weekName: item.name, day: item.day });
      }
    });
  });

  const grouped = groupBy(availableDays, "weekName");
  Object.entries(grouped).forEach(([key, value]) => {
    const day = value[0].day;
    const sortedShift = convertShiftTimes(value, day.toJSDate()).sort(
      (a, b) => a.startTime - b.startTime
    );

    schedule[key] = sortedShift.map((shift) => {
      return {
        name: shift.name,
        availabilityType: shift.availabilityType,
        tables: shift.tables,
        startTime: getShiftTime(shift, shift.startTime, type),
        endTime: getShiftTime(shift, shift.endTime, type),
        allDay: false,
        openDay: getShiftDay(shift, shift.startTime, type),
        closeDay: getShiftDay(shift, shift.endTime, type),
        bookingInterval: shift.timeSlotFrequency,
        totalCapacity: geCapacity(shift, allTables),
        seatingDurations:
          shift?.seatingDuration ?? business.settings?.seatingDuration,
      };
    });
  });

  return schedule;
}

module.exports = {
  generateSchedule,
  getClosedSchedule,
};
